import React, { useLayoutEffect } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import ModuleList from '../../../layout/ModuleList';
import { TRIP_EXPENSE_PATH } from '../../../../config/paths';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { TRIP_EXPENSE_COLUMNS } from '../../../../config/columns';
import { clearTripExpenses, getTripExpenses } from '../../../../actions';

export const TripExpenses = ({
  breadcrumbs,
  tripExpenses,
  loading,
  dispatchGetTripExpenses,
  dispatchClearTripExpenses,
}) => {
  useLayoutEffect(
    () => () => {
      dispatchClearTripExpenses();
    },
    [],
  );

  const data = tripExpenses.get('content') || [];
  const pages = tripExpenses.get('totalPages') || null;
  const defaultPageSize = tripExpenses.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Gasto de Viaje"
      breadcrumbs={breadcrumbs}
      tableStructure={{
        columns: TRIP_EXPENSE_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetTripExpenses,
        loading,
        modelPath: TRIP_EXPENSE_PATH,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetTripExpenses: getTripExpenses,
  dispatchClearTripExpenses: clearTripExpenses,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Gasto de Viaje',
      href: TRIP_EXPENSE_PATH,
    },
  ],
  tripExpenses: AccountingUnit.TripExpense.getIn(['all', 'content']),
  loading: AccountingUnit.TripExpense.getIn(['all', 'loading']),
});

TripExpenses.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  tripExpenses: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetTripExpenses: PropTypes.func.isRequired,
  dispatchClearTripExpenses: PropTypes.func.isRequired,
};

TripExpenses.defaultProps = {
  tripExpenses: [],
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(TripExpenses);
